export const LISTING_CATEGORY= 'LISTING_CATEGORY'
export const LISTING_CATEGORY_SUCCESS= 'LISTING_CATEGORY_SUCCESS'